"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var styles_1 = require("styles");
var componentStyle = {
    example: {
        backgroundColor: '#3498db',
    },
};
var description = 'It\'s totally fine have a custom style.';
var code = "import React from 'react';\nimport { AppBar } from 'jsc-react-ui';\n\nconst style = {\n  base: {\n    backgroundColor: '#3498db',\n  },\n  icon: {\n    color: '#f8f8f8',\n  },\n};\n\nconst AppBarExample = () => (\n  <AppBar style={style.base} toggleDrawerIconColor={style.icon.color} />\n);";
exports.StylingExampleAppBar = function () { return (React.createElement(common_1.Example, { title: "Styling", code: code, description: description },
    React.createElement(components_1.AppBar, { style: componentStyle.example, toggleDrawerIconColor: styles_1.FontColor.White }))); };
exports.StylingExampleAppBar.displayName = 'StylingExampleAppBar';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentAppBarPage/StylingExampleAppBar.tsx
// module id = 631
// module chunks = 0